import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-quotation-settings',
  templateUrl: './quotation-settings.component.html',
  styleUrls: ['./quotation-settings.component.scss']
})
export class QuotationSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
